import { Link } from "react-router-dom";
import { MessageCircle, Facebook, Instagram } from "lucide-react";
import { useLanguage } from "@/lib/useLanguage";
import ServicePageLinks from "@/components/ServicePageLinks";

const SiteFooter = ({ tagline }: { tagline?: string }) => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#1B2A4A] text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Left: Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center font-bold text-sm">
                NT
              </div>
              <span className="font-bold text-lg">NordicThai Translate</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              {tagline ?? t("footer.tagline")}
            </p>
          </div>

          {/* Center: Quick Links */}
          <div>
            <h4 className="font-semibold text-white/80 mb-4 text-sm uppercase tracking-wider">{t("footer.links")}</h4>
            <ul className="space-y-2 text-white/60 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">{t("footer.links.home")}</Link></li>
              <li><Link to="/documents" className="hover:text-white transition-colors">{t("footer.links.documents")}</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">{t("footer.links.process")}</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">{t("footer.links.blog")}</Link></li>
              <li><Link to="/get-quote" className="hover:text-white transition-colors">{t("footer.links.quote")}</Link></li>
              <li><ServicePageLinks footer /></li>
            </ul>
          </div>

          {/* Right: Contact */}
          <div>
            <h4 className="font-semibold text-white/80 mb-4 text-sm uppercase tracking-wider">{t("footer.contact")}</h4>
            <ul className="space-y-3 text-white/60 text-sm">
              <li>
                <a href="https://wa.me/66821858187" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-white transition-colors">
                  <MessageCircle className="w-4 h-4" /> WhatsApp
                </a>
              </li>
              <li>
                <span className="inline-flex items-center gap-2">📍 Hausmanns gate 7, 0186 Oslo</span>
              </li>
              <li className="flex items-center gap-3 pt-1">
                <a href="#" className="hover:text-white transition-colors"><Facebook className="w-4 h-4" /></a>
                <a href="#" className="hover:text-white transition-colors"><Instagram className="w-4 h-4" /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
          <p className="text-center text-xs text-white/40">
            {t("footer.copyright")} · <Link to="/privacy" className="hover:text-white/60 transition-colors">{t("footer.privacy")}</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
